//@ts-nocheck

import React, { useState } from 'react';
import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: inline-flex; // Use inline-flex for better size control
  align-items: center;
  background: #000000;
  border-radius: 12px;
  padding: 8px; // Reduced padding for a tighter look
  width: fit-content; // Adjust width to content
  position: relative;
  overflow: hidden; // Prevent button overflow
`;

const SwitchButton = styled.button`
  position: absolute;
  top: 4px;
  left: ${(props) => (props.active === 'Student' ? '4px' : 'calc(49%)')};
  width: calc(50% - 2px); // Adjust width based on padding
  height: 85%;
  background: transparent;
  border: 2px solid white;
  border-radius: 12px;
  transition: left 0.3s ease-in-out;
  padding: 0;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); // Add subtle shadow for depth
`;

const Option = styled.div`
  flex: 1;
  text-align: center;
  padding: 8px 16px; // Add horizontal padding for better touch area
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  z-index: 1;
  user-select: none; // Prevent text selection
`;

const Switch = () => {
  const [active, setActive] = useState('Student');

  const handleSwitch = (option) => {
    setActive(option);
  };

  return (
    <SwitchContainer
      role="radiogroup"
      aria-label="Switch between Student and Enterprise"
    >
    </SwitchContainer>
  );
};

export default Switch;
